import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

class NotHaveHRMS extends Component {
    render() {
        return (
            <React.Fragment>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12 text-center py-4'>
                            <div className='mb-3 font-14'>To know more about HRMS, please fill in your details and we will get in touch with you soon.</div>
                            <button className='btn btn-danger' onClick={() => { this.props.onToggle() }}>Request Call Back</button>
                        </div>
                    </div>
                </div>
            </React.Fragment>

        )
    }
}
export default withRouter(NotHaveHRMS)